import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { AppCommunicationService } from './app-communication.service';
import { AuthenticationService } from '../../core-frontend-common/auth/authentication.service';
import { Router } from '@angular/router';
import {
  addNotificationUrl,
  getDepartmentCodebookUrl,
  getFacultyCodebookUrl, getNotificationDeleteUrl,
  getNotificationUrl,
  updateNotificationUrl,
} from '../app.urls';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable()
export class GeneralService {
  constructor(
    private http: HttpClient,
    private router: Router,
    private authenticationService: AuthenticationService,
  ) {
  }

  getFaculties(): Observable<any[]> {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${AppCommunicationService.getCurrentUser().access_token}`,
        'Content-Type': 'application/x-www-form-urlencoded',
      }),
    };
    if (this.authenticationService.checkUser()) {
      return this.http.get(getFacultyCodebookUrl(), httpOptions).pipe(map((res: any) => res.items));
    }
  }

  getDepartments(facultyId: number): Observable<any[]> {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${AppCommunicationService.getCurrentUser().access_token}`,
        'Content-Type': 'application/x-www-form-urlencoded',
      }),
    };
    if (this.authenticationService.checkUser()) {
      return this.http.get(getDepartmentCodebookUrl(facultyId), httpOptions).pipe(map((res: any) => res.items));
    }
  }

  addNotification(notification: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${AppCommunicationService.getCurrentUser().access_token}`,
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .post(addNotificationUrl(), notification, httpOptions);
  }

  updateNotification(notification: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${AppCommunicationService.getCurrentUser().access_token}`,
        'Content-Type': 'application/json',
      }),
    };
    return this.http
      .post(updateNotificationUrl(notification.id), notification, httpOptions);
  }

  getNotifications(isForLoginScreen: boolean, application: string): Observable<any[]> {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${AppCommunicationService.getCurrentUser().access_token}`,
        'Content-Type': 'application/json',
      }),
    };

    const query = `isForLoginScreen=${isForLoginScreen}&application=${application}`;

    return this.http
      .post(getNotificationUrl(query), {}, httpOptions)
      .pipe(map((res: any) => res.items));
  }

  deleteNotification(notification): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${AppCommunicationService.getCurrentUser().access_token}`,
      }),
    };

    return this.http
      .delete(getNotificationDeleteUrl(notification.id), httpOptions);
  }
}
